import { AppQueryProvider } from "@/components/query-provider";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/auth-context";
import { OrgProvider } from "@/contexts/org-context";
import { Outlet, rootRouteWithContext } from "@tanstack/react-router";

interface RouterContext {}

export const Route = rootRouteWithContext<RouterContext>()({
  component: () => (
    <AuthProvider>
      <OrgProvider>
        <AppQueryProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
          >
            <Outlet />
            <Toaster />
          </ThemeProvider>
        </AppQueryProvider>
      </OrgProvider>
    </AuthProvider>
  ),
});
